interface BasicFetchProps {
    url: string,
    method?: string,
    data?: any,
    extra?: any,
    contentType?: string, // 'multipart/form-data' | 'application/json'
    onSuccess: (data: any) => void,
    onFail?: (errorMessage: string) => void,
    onFinish?: () => void,
}


export const BasicFetch = ({
    url,
    method,
    data,
    extra,
    contentType = 'application/json',
    onSuccess,
    onFail = () => { },
    onFinish = () => { }
}:
    BasicFetchProps
) => {
    let body = JSON.stringify(data);
    let searchParams = new URLSearchParams({ ...extra, api_key: localStorage.getItem("reptoolCookie") || (window as any).RepToolCookie });
    url = `${url}?${searchParams}`;
    if (contentType !== 'application/json') {
        body = data;
        fetch(url, {
            method,
            mode: 'cors',
            credentials: 'same-origin', // include, *same-origin, omit
            // headers: {
            //     'Content-Type': contentType
            // },
            body  // body data type must match "Content-Type" header
        })
            .then(response => response.json())
            .then(data => {
                if (data.success === false) {
                    throw new Error(data.message);
                }
                if (data.message && data.message === 'Bad token') {
                    (window as any).backToLogin();
                }
                if (data.token) {
                    localStorage.setItem("reptoolCookie", data.token);
                }
                onSuccess(data);
            })
            .finally(() => {
                onFinish();
            })
            .catch((error) => {
                onFail(error.message)
            });
    } else {

        fetch(url, {
            method,
            mode: 'cors',
            credentials: 'same-origin', // include, *same-origin, omit
            headers: {
                'Content-Type': contentType
            },
            body
        })
            .then(response => response.json())
            .then(data => {
                if (data.success === false) {
                    throw new Error(data.message);
                }
                if (data.message && data.message === 'Bad token') {
                    (window as any).backToLogin();
                }
                onSuccess(data);
                if (data.token) {
                    localStorage.setItem("reptoolCookie", data.token)
                }
            })
            .catch((error) => {
                onFail(error.message)
            }).finally(() => {
                onFinish();
            })
    }

}